import React, { useEffect, useRef, useState } from 'react';
import BookImg from '../../Images/img.png'
import '../../Styles/ConfirmLesson.css'
import { useLocation, useNavigate } from 'react-router-dom';
import { MAIN_URL } from '../../constants';
import axios from 'axios'
import { BookOpen, Check, ChevronDown, ClipboardList, FileText, MessageCircle, Undo2 } from 'lucide-react';
import { Badge, Button, Card, EmptyState, Modal, PageHeader, Textarea } from '../ui';
import './Details.css';
import { toast } from 'react-toastify';
import api from '../RefreshToken/RefreshToken';
import Chatbot from '../Chatbot/Index'

const Details = () => {
    const location = useLocation();
    const [courses, setCourses] = useState()
    const courseId = location.state?.course.id;
    const [chapterBtn, setChapterBtn] = useState(false)
    const [activeChapter, setActiveChapter] = useState(null);
    const navigate = useNavigate()
    const returnDescRef = useRef()
    const [returnCourse, setReturnCours] = useState(false)
    const TOKEN = localStorage.getItem("admin_token")
    const [helpViewIndex, setHelpViewIndex] = useState(null);

    const handleView = (lessonIdx) => {
        setHelpViewIndex(prev => prev === lessonIdx ? null : lessonIdx);
    };


    useEffect(() => {
        const getMyCourses = () => {

            api.get(`/management/mentor/course/review?course_id=${courseId}`, {
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${TOKEN}`,
                },
            })
                .then((response) => {
                    setCourses(response.data);
                })
                .catch((error) => {
                    toast.error(`Error fetching: ${error.message || error}`);
                });
        };


        getMyCourses();
    }, []);



    const confirmSubmit = () => {
        axios.post(
            `${MAIN_URL}/management/mentor/confirm-course`,
            {
                course_id: courseId,
            },
            {
                headers: {
                    Authorization: `Bearer ${TOKEN}`,
                    "Content-Type": "application/json",
                },
            }
        )
            .then(response => {
                console.log("Success:", response);
                navigate("/lesson-confirmation")
            })
            .catch(error => {
                console.log("Error:", error);
            });

    }

    const handleReturn = () => {
        setReturnCours(x => !x)
    }

    const returnSubmitCourse = () => {
        axios.post(
            `${MAIN_URL}/management/course/review/issues`,
            {
                course_id: courseId,
                description: returnDescRef.current.value,
            },
            {
                headers: {
                    Authorization: `Bearer ${TOKEN}`,
                    "Content-Type": "application/json",
                },
            }
        )
            .then(response => {
                console.log("Success:", response);
                navigate("/lesson-confirmation")
                toast.success("Successfully verified")
            })
            .catch(error => {
                console.log("Error:", error);
            });

    }

    const handleChapter = (index) => {
        setActiveChapter(activeChapter === index ? null : index);
        setChapterBtn(true)
    }

    const handleTestView = (examData) => {
        navigate('/course-details/chatbot', {state: examData})
        localStorage.setItem('courseLanguage',courses?.language)
    }

    console.log(courses);

    return (
        <div className="ui-review">
            <PageHeader
                title={location.state?.course?.title || "Kursni ko'rib chiqish"}
                subtitle="Boblar, darslar va testlarni tekshirib, kursni tasdiqlang yoki izoh bilan qaytaring."
            />
            {courses?.chapters?.length === 0 ? (
                <Card padding="none">
                    <EmptyState icon={<BookOpen />} title="Kursga hali dars yuklanmagan" />
                </Card>
            ) : (
                <div className="ui-review__chapters">
                    {courses?.chapters?.map((chapter, chapterIndex) => (
                        <div
                            key={chapterIndex}
                            onClick={() => handleChapter(chapterIndex)}
                            className={`ui-review-chapter${activeChapter === chapterIndex ? ' ui-review-chapter--open' : ''}`}
                        >
                            <div className="ui-review-chapter__head">
                                <span className="ui-review-chapter__num">{chapterIndex + 1}</span>
                                <div className="ui-review-chapter__heading">
                                    <h3 className="ui-review-chapter__title">{chapter?.title}</h3>
                                    <span className="ui-review-chapter__meta">{chapter?.lessons?.length || 0} ta dars</span>
                                </div>
                                <ChevronDown className="ui-review-chapter__chevron" aria-hidden="true" />
                            </div>
                            {activeChapter === chapterIndex && (
                                <div className="ui-review-chapter__body" onClick={(e) => e.stopPropagation()}>
                                    {chapter?.lessons?.map((lesson, lessonIndex) => (
                                        <div key={lessonIndex} className="ui-review-lesson">
                                            <div className="ui-review-lesson__main">
                                                <video
                                                    src={lesson?.video_url}
                                                    controls
                                                    className="ui-review-lesson__video"
                                                />
                                                <div className="ui-review-lesson__info">
                                                    <Badge variant="neutral" size="sm">{lessonIndex + 1}-dars</Badge>
                                                    <h4 className="ui-review-lesson__title">{lesson?.title}</h4>
                                                    <div className="ui-review-lesson__desc" dangerouslySetInnerHTML={{ __html: lesson?.description }}></div>
                                                    <div className="ui-review-lesson__actions">
                                                        <a target='_blank' href={lesson?.pdf_url} download className="ui-btn ui-btn--secondary ui-btn--sm" rel="noreferrer">
                                                            <FileText aria-hidden="true" /> PDF material
                                                        </a>
                                                        <Button variant="secondary" size="sm" leftIcon={<MessageCircle />} onClick={() => handleView(lessonIndex)}>
                                                            {helpViewIndex === lessonIndex ? 'Yordamni yopish' : 'Yordam'}
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>
                                            {helpViewIndex === lessonIndex && (
                                                <div className="ui-review-lesson__help">
                                                    <Chatbot socket={"help"} data={lesson?.text_of_video} />
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                    <div className="ui-review-chapter__footer">
                                        <Button variant="secondary" leftIcon={<ClipboardList />} onClick={() => handleTestView(chapter.exam_data)}>
                                            Bob testini ko'rish
                                        </Button>
                                    </div>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            )}

            <div className="ui-review__actions">
                <Button variant="danger" leftIcon={<Undo2 />} onClick={handleReturn}>Qaytarish</Button>
                <Button leftIcon={<Check />} onClick={confirmSubmit}>Tasdiqlash</Button>
            </div>

            <Modal
                open={returnCourse}
                onClose={handleReturn}
                title="Kursni qaytarish"
                subtitle="Kursda nimani tuzatish kerakligini yozing — izoh kurs muallifiga yuboriladi."
                footer={(
                    <>
                        <Button variant="secondary" onClick={handleReturn}>Bekor qilish</Button>
                        <Button variant="danger-solid" onClick={returnSubmitCourse}>Qaytarish</Button>
                    </>
                )}
            >
                <Textarea
                    label="Izoh"
                    name="complaintText"
                    rows={6}
                    placeholder="Masalan: 3-darsdagi video ovozsiz, 2-bob testida javoblar noto'g'ri..."
                    ref={returnDescRef}
                />
            </Modal>
        </div>
    );
}

export default Details;